export const environment = {
  keycloak: {
    url: 'http://localhost:8080',
    realm: 'registrar',
    clientId: 'swagger',
  },
  api: 'http://localhost:3001',
  grafanaUrl: 'http://localhost:3002/d/279d981c-e4e8-40e9-a29a-dfa6c383f6b5',
  production: false,
};
